import builder from '../builder';
import OpenQuote from '../../streamline-icons/light/open-quote.svg';

export default builder('IconOpenQuoteLight', OpenQuote);
